import type { ReactNode } from 'react'

/**
 * EmptyState component for displaying empty states
 */
interface EmptyStateProps {
  /**
   * The title to display
   */
  title?: string
  /**
   * The description to display
   */
  description?: string
  /**
   * Optional illustration/icon rendered above the text
   */
  illustration?: ReactNode
}

export function EmptyState({
  title = 'No items',
  description = 'No items to display at this time.',
  illustration,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col justify-center items-center gap-4 px-6 py-12">
      {illustration}
      <div className="flex flex-col items-center gap-1">
        <p className="text-center text-lg font-semibold text-charcoal">{title}</p>
        {description && <p className="text-center text-charcoal-50">{description}</p>}
      </div>
    </div>
  )
}
